function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawBlogging = function UndrawBlogging(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1050 805.83",
    style: style
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    id: "prefix__a",
    x1: 756.96,
    y1: 364.35,
    x2: 756.96,
    y2: 20.38,
    gradientUnits: "userSpaceOnUse"
  }, React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), React.createElement("linearGradient", {
    id: "prefix__b",
    x1: 919.02,
    y1: 298.54,
    x2: 919.02,
    y2: 260.1,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__c",
    x1: 532.43,
    y1: 677.74,
    x2: 532.43,
    y2: 220.6,
    gradientTransform: "matrix(-1 0 0 1 923.85 0)",
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__d",
    x1: 441.23,
    y1: 805.83,
    x2: 441.23,
    y2: 578.64,
    xlinkHref: "#prefix__a"
  }), React.createElement("linearGradient", {
    id: "prefix__e",
    x1: 467.66,
    y1: 592.77,
    x2: 467.66,
    y2: 390.97,
    xlinkHref: "#prefix__a"
  })), React.createElement("path", {
    d: "M60.45 414.05c35.65 45.33 21.8 111.54-.85 164.58-7.59 17.76-16.16 36.54-13 55.58 3.91 23.28 24.69 40.31 46.51 49.33 39.77 16.45 87.37 12.53 123.92-10.21 31.58-19.65 54.2-51.6 86.32-70.35 53.76-31.38 122.18-19.53 180.55 2.09 41.3 15.29 86.45 35.18 127.48 19.2 28.87-11.25 48.83-38.62 59.71-67.64 5.25-14 9.06-29.17 19.09-40.28 6-6.6 13.74-11.29 21.71-15.24 72.77-36.08 164.67-16.76 235.35-56.77 47.73-27 78.29-78 91.82-131.16s12-108.9 8.52-163.64c-2.44-38.91-6.82-80.44-31.68-110.47C989.6 7.31 944.47-4.51 903.68 1.53s-77.77 27.56-110.3 52.9c-40.65 31.68-78.36 71.12-128.27 84-34 8.74-69.75 4-104.81 2.3-58.61-2.77-117.24 3.39-175.53 10.12-55.8 6.45-112 13.55-165.16 31.7-37.61 12.8-67.75 36.12-103.27 52.37-23.15 10.62-48.4 13.55-70.33 27.08-27 16.66-51.76 45.64-44.84 79.55 6.58 32.27 40.36 48.44 59.28 72.5z",
    fill: primaryColor,
    opacity: 0.1
  }), React.createElement("path", {
    d: "M189.78 612.21s-3.3-97.76-56.19-153c-22.2-23.18-36.78-52.62-40.64-84.48a249.26 249.26 0 0 1-1.24-45.57",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M58.58 294.18c3.62 10.92 33.88 36 33.88 36s9.27-38.21 5.65-49.12a20.824 20.824 0 0 0-39.53 13.11zM46 365.47c9 7.2 48 11.82 48 11.82s-13-37.11-22-44.3a20.82 20.82 0 0 0-26 32.48zM81.65 468.32c11.38 1.68 47.41-14 47.41-14s-29.94-25.48-41.32-27.16a20.824 20.824 0 0 0-6.09 41.2zM126.17 540.06c10.93 3.58 49.1-5.82 49.1-5.82s-25.21-30.17-36.14-33.75a20.825 20.825 0 0 0-13 39.57zM136.17 365.64C130.86 375.84 97 395.82 97 395.82s-3.08-39.19 2.23-49.4a20.82 20.82 0 1 1 36.94 19.22zM187.18 450.2c-8.12 8.15-46.4 17.07-46.4 17.07s8.79-38.32 16.9-46.47a20.82 20.82 0 1 1 29.5 29.39zM225.48 539.19c-6.62 9.4-42.85 24.67-42.85 24.67s2.18-39.25 8.81-48.66a20.82 20.82 0 1 1 34 24zM654.56 545.83s-15.88-5.38-23.52 8.61a25.52 25.52 0 0 0 .34 24.57c5 9.07 15.36 20.85 35 19.8 16.62-.89 22.1-13.57 23.62-25.37a26.06 26.06 0 0 0-34.61-27.9z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M634.74 580.27a25.52 25.52 0 0 1-.34-24.57c7.64-14 23.52-8.61 23.52-8.61l.81-.29a25.83 25.83 0 0 1 18.66.42 25.84 25.84 0 0 0-22-2.1l-.81.29s-15.88-5.38-23.52 8.61a25.52 25.52 0 0 0 .34 24.57c3.31 6 8.92 13.11 18 17a39.35 39.35 0 0 1-14.66-15.32z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M646.36 552.56s5.89 4.63 20.18 0",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M645.1 518.92s10.09 27.33 9.25 34.48l8-.84s-13.46-24-10.09-33.64z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M645.1 518.92s10.09 27.33 9.25 34.48l8-.84s-13.46-24-10.09-33.64z",
    opacity: 0.2
  }), React.createElement("path", {
    d: "M686.29 521.2s-15.88-8.12-23-1.41-8.2 23.86-8.2 23.86 25.91 3.56 31.2-22.45z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M686.29 521.2s-15.88-8.12-23-1.41-8.2 23.86-8.2 23.86 25.91 3.56 31.2-22.45z",
    fill: "#fff",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M655.1 543.65s4.17-19.91 31.19-22.45",
    fill: "none",
    stroke: primaryColor,
    strokeMiterlimit: 10
  }), React.createElement("path", {
    d: "M198.63 424.51s3.24-52.86-22.43-85.34a80.24 80.24 0 0 1-17.57-47.62 135 135 0 0 1 1.68-24.63",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), React.createElement("path", {
    d: "M144.26 246.36c1.39 6.07 16.41 21.15 16.41 21.15s7-20.12 5.57-26.18a11.28 11.28 0 1 0-22 5zM133.8 284.14c4.47 4.34 25.27 8.84 25.27 8.84s-5.09-20.67-9.56-25a11.272 11.272 0 1 0-15.71 16.17zM147.75 341.41c6 1.49 26.27-5.13 26.27-5.13s-14.83-15.27-20.87-16.76a11.273 11.273 0 0 0-5.4 21.89zM168.06 382.35c5.71 2.49 26.76-.62 26.76-.62s-12-17.56-17.74-20a11.27 11.27 0 1 0-9 20.66zM182.41 288.87c-3.38 5.23-22.66 14.25-22.66 14.25s.35-21.28 3.74-26.51a11.272 11.272 0 0 1 18.92 12.26zM205.56 337.06c-4.79 4-25.89 6.82-25.89 6.82s6.7-20.2 11.5-24.18a11.274 11.274 0 0 1 14.39 17.36zM221.63 386.99c-4.05 4.73-24.36 11.1-24.36 11.1s3.19-21 7.25-25.77A11.276 11.276 0 0 1 221.64 387z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M144.26 246.36c1.39 6.07 16.41 21.15 16.41 21.15s7-20.12 5.57-26.18a11.28 11.28 0 1 0-22 5zM133.8 284.14c4.47 4.34 25.27 8.84 25.27 8.84s-5.09-20.67-9.56-25a11.272 11.272 0 1 0-15.71 16.17zM147.75 341.41c6 1.49 26.27-5.13 26.27-5.13s-14.83-15.27-20.87-16.76a11.273 11.273 0 0 0-5.4 21.89zM168.06 382.35c5.71 2.49 26.76-.62 26.76-.62s-12-17.56-17.74-20a11.27 11.27 0 1 0-9 20.66zM182.41 288.87c-3.38 5.23-22.66 14.25-22.66 14.25s.35-21.28 3.74-26.51a11.272 11.272 0 0 1 18.92 12.26zM205.56 337.06c-4.79 4-25.89 6.82-25.89 6.82s6.7-20.2 11.5-24.18a11.274 11.274 0 0 1 14.39 17.36zM221.63 386.99c-4.05 4.73-24.36 11.1-24.36 11.1s3.19-21 7.25-25.77A11.276 11.276 0 0 1 221.64 387z",
    fill: "#fff",
    opacity: 0.5
  }), React.createElement("path", {
    fill: "url(#prefix__a)",
    d: "M504.5 20.39V364.35h504.92V20.39H504.5z"
  }), React.createElement("path", {
    fill: "#fff",
    d: "M511.99 35.99h492.08v322.13H511.99z"
  }), React.createElement("path", {
    fill: "#eee",
    d: "M511.99 20.67h492.08v23.7H511.99z"
  }), React.createElement("circle", {
    cx: 530.71,
    cy: 32.16,
    r: 5.75,
    fill: "#ff5252"
  }), React.createElement("circle", {
    cx: 546.52,
    cy: 32.16,
    r: 5.75,
    fill: "#ff0"
  }), React.createElement("circle", {
    cx: 562.32,
    cy: 32.16,
    r: 5.75,
    fill: "#69f0ae"
  }), React.createElement("path", {
    fill: primaryColor,
    opacity: 0.5,
    d: "M530.85 82.33h183.37v7.64H530.85zM530.85 97.61h183.37v7.64H530.85zM530.85 112.89h183.37v7.64H530.85zM594.05 128.17h120.16v7.64H594.05zM530.85 143.46h96.55v7.64h-96.55zM582.94 158.74h74.32v7.64h-74.32zM738.53 135.82h216.02v124.33H738.53z"
  }), React.createElement("path", {
    fill: "#eee",
    d: "M764.23 147.62h216.02v124.33H764.23z"
  }), React.createElement("path", {
    d: "M885.09 271.92H764.23v-22.74c29.53-13.8 74.96-21.55 120.86 22.74z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M978.86 268.7v3.22H828.13v-.69s74.17-72.18 150.73-2.53z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M980.25 268.7v3.22H829.52v-.69s74.17-72.18 150.73-2.53z",
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 789.24,
    cy: 169.85,
    r: 11.11,
    fill: primaryColor
  }), React.createElement("path", {
    d: "M883.85 161.43c-1.27 0-2.69 0-3.65.08a4.44 4.44 0 0 0-1.27.26l-6.54 2.35c5.28.13 10.79.09 16.19 0l30.34-.23c3.09 0 6.35-.05 8.93-.24 1.73-.12 3-.31 4.59-.45 5.74-.51 14.12-.41 21.6-.39s16.51-.17 19.14-.92h-16.05c-1.73 0-3.55 0-5.08-.09-1.79-.1-2.88-.3-4.45-.44-2.6-.22-6.18-.25-9.52-.26-18.28-.01-36.35.43-54.23.33zM901.86 174.92h-.79a1 1 0 0 0-.27.06l-1.42.51h3.51l6.57-.05c.67 0 1.37 0 1.93-.05l1-.1c1.24-.11 3.06-.09 4.68-.08a25.5 25.5 0 0 0 4.15-.2h-4.58c-.33 0-.62-.07-1-.09-.56 0-1.34-.05-2.06-.06-3.94-.02-7.85.06-11.72.06zM855.32 194.36h-.79a1 1 0 0 0-.27.06l-1.42.51h3.51l6.57-.05c.67 0 1.37 0 1.93-.05l1-.1c1.24-.11 3.06-.09 4.68-.08a25.5 25.5 0 0 0 4.15-.2h-4.58c-.33 0-.62-.07-1-.09-.56 0-1.34-.05-2.06-.06-3.93-.01-7.85.08-11.72.06z",
    fill: "#f4f4f4"
  }), React.createElement("path", {
    d: "M829.18 265.79H824s-1.63-57.12 5.22-74.75h1.31s-4.61 64.64-1.35 74.75z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M825.59 188.11s-4.24 11.75-2.28 17c0 0 2.94-10.77 6.37-12.4s7 12.4 7 12.4 2-8.81-1.63-16a28.38 28.38 0 0 1 10.77 11.42s.65-4.9-7.83-15c0 0 7.51 2 12.4 6.53 0 0 1.63-3.59-8.49-9.47 0 0 1.31-4.24 9.14-2.28 0 0 0-5.55-12.4-4.57 0 0 0-3.59 8.16-2.94 0 0 0-4.57-9.47-2.94 0 0 2-2.94 3.26-3.59a6.56 6.56 0 0 0-4.57 1.31s.33-5.88-4.57-8.16l-.65 8.16s-5.49-6.47-4.24-5.22a14.32 14.32 0 0 1 1 6.2s-5.55-4.57-12.4.33c0 0 8.49.65 9.79 3.59 0 0-7.18-1.31-8.81-.33 0 0 5.55 2 5.22 3.26 0 0-9.79 0-11.1 3.59 0 0 10.12 1.31 10.77 2.28 0 0-11.75 8.49-12.4 10.77 0 0 12.08-7.18 14-7.18s-8.81 10.45-8.16 13.06c.03-.01 8.84-10.48 11.12-9.82zM893.61 263.66h4s1.25-43.64-4-57.11h-1s3.49 49.37 1 57.11z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M896.35 204.3s3.24 9 1.75 13c0 0-2.24-8.23-4.86-9.48s-5.36 9.48-5.36 9.48-1.5-6.73 1.25-12.22a21.68 21.68 0 0 0-8.23 8.73s-.5-3.74 6-11.47c0 0-5.74 1.5-9.48 5 0 0-1.25-2.74 6.48-7.23 0 0-1-3.24-7-1.75 0 0 0-4.24 9.48-3.49 0 0 0-2.74-6.23-2.24 0 0 0-3.49 7.23-2.24a11 11 0 0 0-2.49-2.74 5 5 0 0 1 3.49 1s-.25-4.49 3.49-6.23l.5 6.23s4.19-4.94 3.24-4a10.94 10.94 0 0 0-.75 4.74s4.24-3.49 9.48.25c0 0-6.48.5-7.48 2.74 0 0 5.49-1 6.73-.25 0 0-4.24 1.5-4 2.49 0 0 7.48 0 8.48 2.74 0 0-7.73 1-8.23 1.75 0 0 9 6.48 9.48 8.23 0 0-9.23-5.49-10.72-5.49s6.73 8 6.23 10c0-.07-6.73-8.05-8.48-7.55zM941.35 255.13h2.47s.77-27-2.47-35.37h-.62s2.16 30.58.62 35.37z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M943 218.37s2 5.56 1.08 8c0 0-1.39-5.1-3-5.87s-3.32 5.87-3.32 5.87a12.9 12.9 0 0 1 .77-7.57 13.43 13.43 0 0 0-5.1 5.41s-.31-2.32 3.71-7.1a15.67 15.67 0 0 0-5.87 3.09s-.77-1.7 4-4.48c0 0-.62-2-4.32-1.08 0 0 0-2.63 5.87-2.16 0 0 0-1.7-3.86-1.39 0 0 0-2.16 4.48-1.39a6.79 6.79 0 0 0-1.54-1.7 3.11 3.11 0 0 1 2.16.62 4.18 4.18 0 0 1 2.16-3.86l.31 3.86s2.6-3.06 2-2.47a6.77 6.77 0 0 0-.46 2.93 4.81 4.81 0 0 1 5.87.15s-4 .31-4.63 1.7c0 0 3.4-.62 4.17-.15 0 0-2.63.93-2.47 1.54 0 0 4.63 0 5.25 1.7 0 0-4.79.62-5.1 1.08 0 0 5.56 4 5.87 5.1 0 0-5.71-3.4-6.64-3.4s4.17 4.94 3.86 6.18c.05.02-4.12-4.92-5.25-4.61z",
    fill: primaryColor
  }), React.createElement("path", {
    d: "M926 271.65l-.52-2.78a1.51 1.51 0 0 0-.47-1.09l-2.41-1.18a2.73 2.73 0 0 1-.43-.72v-.06a1.45 1.45 0 0 0 .28-.57 1 1 0 0 0 0-.16.89.89 0 0 0 1-.72v-.06a.89.89 0 0 1-.81.67 2.46 2.46 0 0 0 1.09-2v-.1a.89.89 0 0 0 .41-.6v-.06a.89.89 0 0 1-.43.56 2.45 2.45 0 0 0-.15-.67h.06a.89.89 0 0 0 .89-.89v-.06a.89.89 0 0 1-.89.83h-.11a1.46 1.46 0 0 0 1-1.19v-.06a.89.89 0 0 1-.18.48.89.89 0 0 0-1.77-.26l-.16-.09a.89.89 0 0 1 .81-.65h-.06a.89.89 0 0 0-.86.6 2.46 2.46 0 0 0-3.1.89c-.19.14-.43.34-.42.51a1.7 1.7 0 0 0-.21.26 3.41 3.41 0 0 0-.28 1.85 2 2 0 0 1-.64 1.7.85.85 0 0 0 .66 0 2.51 2.51 0 0 0 .58-.34 1.29 1.29 0 0 0 .41-.39 2 2 0 0 0 .37.19c.05.42.06.9-.12 1.05v-.08a2.26 2.26 0 0 1-1.57.45 2 2 0 0 0-1.62 1l-.75 3.21v.1a.24.24 0 0 0 .18.18l.23.06A4.9 4.9 0 0 1 916 273a13.7 13.7 0 0 0-.27 2.36c.06.4.16 2.46.2 3.44a10.19 10.19 0 0 0-.2 1l-1.12 6.71s-.83 5.37-.79 7l-.15.94s-2.27 2.85-1.6 3.25 1.69.58 2.67-.94a2.45 2.45 0 0 1 .62-.94.92.92 0 0 0 .31-.78l-.07-.66h.19a23.18 23.18 0 0 0 1-6.24s2.07-7.38 3.65-8.54l.15-.07.34 7.14-.34 7.88-.07.47s-2.27 2.85-1.6 3.25 1.69.58 2.67-.94a2.45 2.45 0 0 1 .62-.94.92.92 0 0 0 .31-.78l-.1-1c.39-1.32 1.4-5.15 1-7.36l.69-4.71c.7-.78.6-2.77.6-2.77.55-1.14.67-5.64.67-5.64l.14-2.22h.42l.05-.06v-.05zm-1.94 4.51c-.06-.15-.13-.31-.21-.46h-.06V275.53a1.92 1.92 0 0 0 .08-.23.87.87 0 0 0 .13-.48 4.54 4.54 0 0 1 .1 1.34zm-.21-1.9l-.14-1.49v-.12l.19 1.89zm-6.59.2a.52.52 0 0 0-.12.4 1.69 1.69 0 0 0 .06.45l-.22.93v-1.78a3.93 3.93 0 0 0 .37-.6 1 1 0 0 1-.04.6z",
    transform: "translate(-75 -47.08)",
    fill: "url(#prefix__b)"
  }), React.createElement("path", {
    d: "M843.71 215.92a3.28 3.28 0 0 0-.27 1.78 1.89 1.89 0 0 1-.62 1.64.82.82 0 0 0 .63 0 2.42 2.42 0 0 0 .56-.33 1.24 1.24 0 0 0 .39-.38 1.48 1.48 0 0 0 .09-.76 8 8 0 0 1 .12-1.35c0-.28.31-1 0-1.18s-.76.36-.9.58z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M839.12 245.43l-.21 1.37s-2.19 2.75-1.54 3.13 1.63.56 2.57-.9a2.36 2.36 0 0 1 .6-.9.89.89 0 0 0 .3-.75l-.21-2.12zM845.71 245.98l-.21 1.37s-2.19 2.75-1.54 3.13 1.63.56 2.57-.9a2.36 2.36 0 0 1 .6-.9.89.89 0 0 0 .3-.75l-.21-2.12z",
    fill: "#333"
  }), React.createElement("path", {
    d: "M842.3 229.37s-1 .74-1.41 3.33l-1.08 6.46a57 57 0 0 0-.74 7l1.82.62a22.33 22.33 0 0 0 1-6s2.19-7.79 3.72-8.34l.32 6.88-.34 7.76 1.56.31s1.58-4.93 1.08-7.54l.81-5.55a8.22 8.22 0 0 0-.36-5.53z",
    fill: "#4d8af0"
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M845.43 232.54v-.12c-1.53.55-3.72 8.34-3.72 8.34a21.88 21.88 0 0 1-.94 5.94l.2.07a22.33 22.33 0 0 0 1-6s1.94-7.11 3.46-8.23zM848.71 228.75h-.21a8.23 8.23 0 0 1 .35 5.51l-.81 5.55c.48 2.47-.92 7-1.06 7.5h.2s1.58-4.93 1.08-7.54l.81-5.55a8.22 8.22 0 0 0-.36-5.47z"
  })), React.createElement("path", {
    d: "M840.9 224.31a.23.23 0 0 0 .18.23 3.6 3.6 0 0 1 1.38.66c.77.6-.81-1.2-.81-1.2l-.53.12-.22.19z",
    fill: "#f55f44"
  }), React.createElement("path", {
    d: "M840.9 224.31a.23.23 0 0 0 .18.23 3.6 3.6 0 0 1 1.38.66c.77.6-.81-1.2-.81-1.2l-.53.12-.22.19z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M848.42 225.92a4.83 4.83 0 0 1 2.17-.86.2.2 0 0 0 .2-.2 1.73 1.73 0 0 0-2.37 1.06z",
    fill: "#f55f44"
  }), React.createElement("path", {
    d: "M850.79 224.83a1.73 1.73 0 0 0-2.37 1.06s1.34-1 2.27-.86",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 846.31,
    cy: 216.46,
    r: 2.37,
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M844.67 218.12s.34 1.39 0 1.68-1 .81-.5 1.22 2.32 1.1 2.92.77 1.29-.24 1.13-.93-1.48-.55-1.51-4z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M841.32 223.92a8.67 8.67 0 0 1-.14 2.25 13.2 13.2 0 0 0-.26 2.27c.07.5.22 3.81.22 3.81s-.26 2.9 1.15 2.63-.22-3.3-.22-3.3l.07-4a3.69 3.69 0 0 0 .72-1.77c.06-.89-1.54-1.89-1.54-1.89z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M841.29 223.92a8.67 8.67 0 0 1-.14 2.25 13.2 13.2 0 0 0-.26 2.27c.07.5.22 3.81.22 3.81s-.26 2.9 1.15 2.63-.22-3.3-.22-3.3l.07-4a3.69 3.69 0 0 0 .72-1.77c.07-.89-1.54-1.89-1.54-1.89z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M850.32 224.11l-.19 3.09s-.12 4.33-.65 5.43c0 0 .14 3-1.27 3s.24-3.33.24-3.33.76-3.38.37-4.46l-.37-3.71z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M850.34 224.11l-.19 3.09s-.12 4.33-.65 5.43c0 0 .14 3-1.27 3s.24-3.33.24-3.33.76-3.38.37-4.46l-.37-3.71z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M845.75 221.11s1.14.53 1.77-1l2.33 1.14a1.45 1.45 0 0 1 .45 1.05l.5 2.68a1.71 1.71 0 0 0-2.23 1l.14 1.51a1.62 1.62 0 0 1-.07 1.13.25.25 0 0 0 0 .2.74.74 0 0 1-.67 1 14.12 14.12 0 0 0-1.87.14c-.5.14-2-.29-2.51 0s-1.56-.22-1.56-.22l.29-1.22s-.19-.6 0-.81a5.21 5.21 0 0 0-.12-2.61s-.86-.81-1.36-.67l.72-3.09a1.88 1.88 0 0 1 1.56-1 2.18 2.18 0 0 0 1.51-.43s-.56 1.01 1.12 1.2z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M845.87 221.06c.31.08 1.15.18 1.65-1.08l2.33 1.14a1.45 1.45 0 0 1 .45 1.05l.5 2.68a1.71 1.71 0 0 0-2.23 1l.14 1.51.09.3a.85.85 0 0 1-.12.76.27.27 0 0 0 0 .28.74.74 0 0 1-.67 1 14.12 14.12 0 0 0-1.87.14c-.5.14-2-.29-2.51 0s-1.56-.22-1.56-.22l.29-1.22s-.19-.6 0-.81a5.21 5.21 0 0 0-.12-2.61s-.86-.81-1.36-.67l.72-3.09a1.88 1.88 0 0 1 1.56-1 2.18 2.18 0 0 0 1.51-.43s-.56 1 .92 1.25z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M845.87 221.11c.31.08 1.15.18 1.65-1.08l2.33 1.14a1.45 1.45 0 0 1 .45 1.05l.5 2.68a1.71 1.71 0 0 0-2.23 1l.14 1.51a1.62 1.62 0 0 1-.07 1.13.25.25 0 0 0 0 .2.74.74 0 0 1-.67 1 14.12 14.12 0 0 0-1.87.14c-.5.14-2-.29-2.51 0s-1.56-.22-1.56-.22l.29-1.22s-.19-.6 0-.81a5.21 5.21 0 0 0-.12-2.61s-.86-.81-1.36-.67l.72-3.09a1.88 1.88 0 0 1 1.56-1 2.18 2.18 0 0 0 1.51-.43s-.56 1 .92 1.25z",
    fill: "#f55f44"
  }), React.createElement("path", {
    d: "M846.75 216.97l-2 1.27a6.61 6.61 0 0 1 .12.66 2 2 0 0 0 .73.14 2.05 2.05 0 0 0 1.32-.6 7.91 7.91 0 0 1-.17-1.47z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 845.52,
    cy: 216.96,
    r: 1.96,
    fill: "#fdb797"
  }), React.createElement("circle", {
    cx: 848.42,
    cy: 214.59,
    r: 0.86,
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M848.58 215.5a.86.86 0 0 1-.86-.8v.06a.86.86 0 1 0 1.72 0v-.06a.86.86 0 0 1-.86.8z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M848.09 216.36a.86.86 0 0 1-.7-.94v.06a.864.864 0 0 0 1.7.31v-.06a.86.86 0 0 1-1 .63zM847.42 218.42a.86.86 0 0 1-.7-.94v.06a.864.864 0 1 0 1.7.31v-.06a.86.86 0 0 1-1 .63zM848.58 215.05a.86.86 0 0 1-.86-.8v.06a.86.86 0 0 0 1.72 0v-.06a.86.86 0 0 1-.86.8z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M847.38 214.58a.86.86 0 0 1 .81-.85h-.06a.86.86 0 0 0 0 1.72h.06a.86.86 0 0 1-.81-.87z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M848.25 222.71a3.1 3.1 0 0 1 0 1.29s-.12 1.13.07 1.32M842.43 222.92a3.1 3.1 0 0 1 0 1.29s-.12 1.13.07 1.32M842.38 227.59a.86.86 0 0 0 .57 0 1.2 1.2 0 0 1 .69 0M842.67 225.92a5 5 0 0 0 2-.31s2.44.6 3.14.17",
    opacity: 0.1
  }), React.createElement("rect", {
    x: 840.9,
    y: 236.21,
    width: 1.51,
    height: 0.93,
    rx: 0.42,
    ry: 0.42,
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M840.9 236.45h.81l.7.11h-.25zM846.33 232.57h.81l.7.07h-.25zM846.33 232.74h.81l.7.07h-.25zM846.33 232.92h.81l.7.07h-.25zM846.33 233.07h.81l.7.07h-.25zM840.9 237.11h.81l.7.08h-.25zM840.9 237.03h.81l.7.08h-.25zM840.9 236.92h.81l.7.08h-.25zM840.9 236.86h.81l.7.08h-.25zM840.9 236.34h.81l.7.11h-.25zM840.9 236.2h.81l.7.11h-.25z",
    fill: "#f0e4e4"
  }), React.createElement("path", {
    d: "M845.85 215.7a4.75 4.75 0 0 0 .27 2.16 2.58 2.58 0 0 1-.12 2.06.68.68 0 0 0 .61-.15 2.37 2.37 0 0 0 .44-.52 1.39 1.39 0 0 0 .27-.54 2.15 2.15 0 0 0-.14-.91 11.77 11.77 0 0 1-.29-1.62c0-.33 0-1.29-.37-1.38s-.6.62-.67.9z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M845.9 215.68a4.75 4.75 0 0 0 .27 2.16 2.58 2.58 0 0 1-.11 2.08.68.68 0 0 0 .61-.15 2.37 2.37 0 0 0 .44-.52 1.39 1.39 0 0 0 .27-.54 2.15 2.15 0 0 0-.14-.91 11.77 11.77 0 0 1-.29-1.62c0-.33 0-1.29-.37-1.38s-.58.6-.68.88z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M845.06 216.19c.16.17.2.43.34.63a1.23 1.23 0 0 0 1 .39.55.55 0 0 1 .28.06c.15.1.16.32.26.47a.55.55 0 0 0 .82 0 1.34 1.34 0 0 0 .24-.82 5.35 5.35 0 0 0 0-1 1.59 1.59 0 0 0-.44-1.06 1.84 1.84 0 0 0-.77-.33 2.28 2.28 0 0 0-1.19-.09 2.14 2.14 0 0 0-.54.27l-.7.47c-.26.18-.74.54-.27.74.34.07.72 0 .97.27z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M845.11 216.17c.16.17.2.43.34.63a1.23 1.23 0 0 0 1 .39.55.55 0 0 1 .28.06c.15.1.16.32.26.47a.55.55 0 0 0 .82 0 1.34 1.34 0 0 0 .31-.86 5.35 5.35 0 0 0 0-1 1.59 1.59 0 0 0-.44-1.06 1.84 1.84 0 0 0-.77-.33 2.28 2.28 0 0 0-1.19-.09 2.14 2.14 0 0 0-.54.27l-.7.47c-.26.18-.74.54-.27.74.27.06.64.06.9.31z",
    fill: "#72351c"
  }), React.createElement("path", {
    d: "M846.38 232.57h.81l.7.07h-.25zM846.38 232.74h.81l.7.07h-.25zM846.38 232.92h.81l.7.07h-.25zM846.38 233.07h.81l.7.07h-.25zM846 242.3h.81l.7.07h-.25zM846 242.46h.81l.7.07h-.25zM846 242.63h.81l.7.07h-.25zM846 242.8h.81l.7.07h-.25z",
    fill: "#f0e4e4"
  }), React.createElement("path", {
    d: "M392.38 694.68h-79.54v-44.81h79.54zm-76.18-3.36H389v-38.09h-72.8z",
    fill: primaryColor,
    opacity: 0.2
  }), React.createElement("path", {
    d: "M334.9 674.58c5 2.92 10.27 4.11 15.72 2.3a24.38 24.38 0 0 0 4.09-1.81c51 1.08 98.23.58 100.06-4.91 3-9.1-16-53.92-25.59-75.58a24.28 24.28 0 0 0 7-7.31c13.32 15.23 38.1 34.88 52.83 35.86 0 0 21.5 51.07 45.69 43s26.88-51.07 14.78-56.44l-80.63-51.07v-84.74a31.74 31.74 0 0 0 3.37-15.7c0-1 .05-2 0-3l-2.69-24.19s-.14-.8-.51-2.25c-6-23.31-19.37-39-38.22-41.33a13.77 13.77 0 0 0 1.64-5.43c.39-4.52-1.49-9.13-.43-13.54 1.24-5.14 6-8.46 9.91-12 8.35-7.64 13.61-18 18.69-28.11 4.84-9.63 9.75-19.51 11-30.21s-2-22.58-10.75-28.88c-6.8-4.91-16.37-6.2-21.26-13-2.19-3.06-3.1-6.83-4.61-10.27-4.35-9.91-13.73-16.94-23.91-20.61-35.72-12.86-79.54 1.9-102.33 31.56-7.44 9.68-12.81 20.76-18.12 31.75l-19.2 39.69c-3.31 6.83-6.51 15.36-2.09 21.53 2.16 3 5.86 4.86 7.36 8.25 2 4.5-.5 10.39 2.44 14.35 1.62 2.19 4.43 3.06 6.84 4.34a26.78 26.78 0 0 1 8.27 7.33l-42.16 32.67a28.39 28.39 0 0 0-10.86 19.61L237.06 478a50.56 50.56 0 0 0-1.88 14.51c-.15 4.38.36 9.21 2.55 13l.92-.22c1 29.15 2.74 71.09 4.46 78.84 1 4.6 7.31 12.71 15.81 21.07l-3 8.5h1l-1 2.67h2c-8.48 30.64-31.55 53.73-31.55 53.73s53.35 2.9 108.53 4.48zM284.76 533v-32.67c4.92.76 8.55 2.46 9.71 5.56zM299 390.82l.16.24h-.06z",
    transform: "translate(-75 -47.08)",
    fill: "url(#prefix__c)"
  }), React.createElement("path", {
    d: "M345.31 417.92s2.55 90.62 5.11 102.11 39.58 45.99 58.71 47.27c0 0 20.42 48.5 43.4 40.84s25.53-48.5 14-53.61L390 506.03v-97z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M347.23 529.01s33.19 71.48 29.36 83-217 0-217 0 39.57-39.57 31.91-83z",
    fill: "#565171"
  }), React.createElement("path", {
    d: "M321.7 317.13s-5.11 49.78 3.83 61.27-35.74 17.86-39.53 17.86-44.67-14-52.33-17.87-14-31.91-14-31.91 38.29 7.66 49.78-37z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M335.08 189.44c9.67 3.48 18.58 10.16 22.71 19.57 1.44 3.27 2.3 6.85 4.38 9.76 4.64 6.48 13.73 7.7 20.19 12.37 8.29 6 11.36 17.27 10.21 27.43s-5.82 19.55-10.41 28.69c-4.83 9.61-9.82 19.44-17.75 26.7-3.7 3.39-8.24 6.54-9.42 11.42-1 4.19.78 8.56.4 12.86-.92 10.61-13.6 15.55-24.19 16.73-4.6.51-9.87.54-13.11-2.77-1.66-1.7-2.49-4-3.55-6.14a29.43 29.43 0 0 0-52.49-.54c-2.48 4.78-3.93 10.57-8.45 13.49-6.92 4.47-16.17-.78-21.26-7.24s-8.8-14.58-16.07-18.45c-2.29-1.22-5-2-6.49-4.12-2.79-3.76-.42-9.35-2.31-13.63-1.43-3.22-4.94-5-7-7.84-4.2-5.86-1.16-14 2-20.45l18.24-37.7c5-10.44 10.15-21 17.21-30.16 21.61-28.18 63.23-42.2 97.16-29.98z",
    fill: "#8f5a6a"
  }), React.createElement("path", {
    d: "M288.52 387.33s-49.78 0-62.54-45.95l-41.9 32.47a27 27 0 0 0-10.31 18.63l-4 39.53s-4.47 14.68.64 23.61c0 0 53-13.4 54.25 1.91l-36.98 103.39s57.44 1.28 72.75-8.93c0 0 62.54 12.76 77.86-1.28s30.63-12.76 17.87-44.67c0 0 25.53-25.53 14-61.27s-.64.64-.64.64 24.89-12.13 23.61-35.1l-2.55-23s-.14-.76-.49-2.13c-7.78-30.28-28.69-47-58.08-36.34-8.59 3.11-17.37-.45-17.37-.45s9.61 41.53-26.12 38.94z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M288.52 384.78s-49.78 0-62.54-45.95l-41.9 32.47a27 27 0 0 0-10.31 18.62l-4 39.53s-4.47 14.68.64 23.61c0 0 53-13.4 54.25 1.91l-37 103.39s57.44 1.28 72.75-8.93c0 0 62.54 12.76 77.86-1.28s30.63-12.76 17.87-44.67c0 0 25.53-25.53 14-61.27s-.64.64-.64.64 24.89-12.13 23.61-35.1l-2.55-23s-.14-.76-.49-2.13c-7.78-30.28-28.69-47-58.08-36.34-8.59 3.11-17.37-.45-17.37-.45s9.63 41.5-26.1 38.95z",
    fill: "#b45181"
  }), React.createElement("path", {
    d: "M170.45 428.17s2.55 90.62 5.11 102.11 39.57 45.95 58.71 47.23c0 0 20.42 48.5 43.4 40.84s25.53-48.5 14-53.61l-76.58-48.5v-97z",
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M225.33 431.36s-29.33 19.92-54.88 18.26c0 0-2.55-34.21 5.11-36.12s40.84 0 49.77 17.86z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M225.33 430.09s-29.33 19.92-54.88 18.25c0 0-2.55-34.21 5.11-36.12s40.84 0 49.77 17.87z",
    fill: "#b45181"
  }), React.createElement("path", {
    d: "M266.82 312.02l52.33 7.66s-1.18 11.52-1.41 24.75a58.74 58.74 0 0 1-61.59-10c4.38-5.4 8.16-12.66 10.67-22.41z",
    opacity: 0.1
  }), React.createElement("circle", {
    cx: 297.45,
    cy: 287.77,
    r: 58.71,
    fill: "#fdb797"
  }), React.createElement("path", {
    d: "M282 276.49c2.42 1.12 5.18 1.14 7.85 1.12q15.58-.1 31.13-1.15c7.86-.53 16.24-1.45 22.3-6.48 8.16-6.77 9.45-19.46 5.24-29.19s-12.8-16.9-21.87-22.38a65.29 65.29 0 0 0-16.52-7.49c-16.83-4.57-35.44 1-48.81 12.25s-21.89 27.38-26.4 44.23c-1.56 5.83-3.56 12.77-9.33 14.54 3.84 6.39 13.21 7.4 19.95 4.2 9.92-4.72 15-22.78 23.91-25.62 9.91-3.13 4.13 12.11 12.55 15.97z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M282 275.21c2.42 1.12 5.18 1.14 7.85 1.12q15.58-.1 31.13-1.15c7.86-.53 16.24-1.45 22.3-6.48 8.16-6.77 9.45-19.46 5.24-29.19s-12.8-16.9-21.87-22.38a65.29 65.29 0 0 0-16.49-7.44c-16.83-4.57-35.44 1-48.81 12.25s-21.89 27.38-26.4 44.23c-1.56 5.83-3.56 12.77-9.33 14.54 3.84 6.39 13.21 7.4 19.95 4.2 9.92-4.72 15-22.78 23.91-25.62 9.88-3.17 4.1 12.06 12.52 15.92z",
    fill: "#8f5a6a"
  }), React.createElement("path", {
    d: "M356.8 502.84a226.11 226.11 0 0 0-58.71-7.66M225.33 433.92s19.15 14 14 21.7",
    opacity: 0.1
  }), React.createElement("path", {
    fill: "url(#prefix__d)",
    d: "M754.58 578.64h-626.7v54.79h36.48v172.41H719.4V633.43h35.18v-54.79z",
    opacity: 0.7
  }), React.createElement("path", {
    fill: "#e0e0e0",
    d: "M170 610.55h543.73v195.29H170z"
  }), React.createElement("path", {
    opacity: 0.1,
    d: "M170 620.76h543.73v30.63H170z"
  }), React.createElement("path", {
    fill: "#e0e0e0",
    d: "M134.26 588.85H748.2v52.33H134.26z"
  }), React.createElement("rect", {
    x: 250.26,
    y: 575.97,
    width: 117.43,
    height: 16.59,
    rx: 6.5,
    ry: 6.5,
    fill: "#535461"
  }), React.createElement("rect", {
    x: 321.73,
    y: 390.97,
    width: 291.85,
    height: 201.8,
    rx: 28.22,
    ry: 28.22,
    fill: "url(#prefix__e)",
    opacity: 0.7
  }), React.createElement("rect", {
    x: 326.94,
    y: 394.7,
    width: 276.47,
    height: 198.07,
    rx: 26.84,
    ry: 26.84,
    fill: "#3e3f49"
  }), React.createElement("rect", {
    x: 330.77,
    y: 394.7,
    width: 276.47,
    height: 198.07,
    rx: 26.84,
    ry: 26.84,
    fill: "#535461"
  }), React.createElement("circle", {
    cx: 481.92,
    cy: 492.37,
    r: 8.93,
    fill: "#e0e0e0"
  }));
};
UndrawBlogging.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawBlogging;